export enum IntegrationType {
  Connectwise = 1,
  Aws,
  MicrosoftAtp,
  CloudUss,
  Nimbus,
  Outthink,
}
